// src/locales/ta/offlineSales.js — Tamil
import { offlineSales as offlineSalesEn } from '../en/offlineSales';

export const offlineSales = {
  ...offlineSalesEn,

  // Navigation / general
  posTerminal: 'POS முனையம்',
  posOrders: 'POS ஆர்டர்கள்',
  posCustomers: 'POS வாடிக்கையாளர்கள்',
  posSessions: 'காசாளர் அமர்வுகள்',
  posSettings: 'POS அமைப்புகள்',
  pointOfSale: 'விற்பனை புள்ளி',
  offlineSalesOrders: 'ஆஃப்லைன் விற்பனை ஆர்டர்கள்',
  receivables: 'பெறத்தக்கவை',
  deliveryDetails: 'விநியோக விவரங்கள்',
  deliveryCity: 'விநியோக நகரம்',
  deliveryAddress: 'விநியோக முகவரி',
  deliveryAddressPlaceholder: 'விநியோக முகவரியை உள்ளிடவும்',
  deliveryCharge: 'விநியோகக் கட்டணம்',
  packageWeightKg: 'பேக்கேஜ் எடை (kg)',
  notSet: 'நிர்ணயிக்கப்படவில்லை',

  // Terminal top bar
  session: 'அமர்வு',
  sessionOpen: 'திறந்துள்ளது',
  sessionClosed: 'மூடப்பட்டது',
  noSession: 'அமர்வு இல்லை',
  openSession: 'அமர்வைத் திற',
  closeSession: 'அமர்வை மூடு',
  exitTerminal: 'முனையத்திலிருந்து வெளியேறு',
  selectWarehouse: 'கிடங்கைத் தேர்ந்தெடு',

  // Cart
  cart: 'கார்ட்',
  emptyCart: 'கார்ட் காலியாக உள்ளது',
  emptyCartHint: 'ஒரு தயாரிப்பைத் தேடவும் அல்லது கார்ட்டில் சேர்க்க ஸ்கேன் செய்யவும்',
  qty: 'அளவு',
  lineDiscount: 'தள்ளுபடி',
  lineTotal: 'மொத்தம்',
  subtotal: 'கூட்டுத்தொகை',
  itemDiscount: 'பொருள் தள்ளுபடிகள்',
  loyaltyDiscount: 'விசுவாச தள்ளுபடி',

  // Actions
  holdOrder: 'நிறுத்தி வை',
  clearCart: 'அழி',
  applyDiscount: 'தள்ளுபடி',
  redeemLoyalty: 'விசுவாசம்',
  charge: 'கட்டணம்',
  completeSale: 'விற்பனையை முடி',
  printReceipt: 'ரசீதை அச்சிடு',
  newSale: 'புதிய விற்பனை',

  // Session gate
  sessionRequired: 'அமர்வு தேவை',
  sessionRequiredMsg: 'விற்பனையைச் செயலாக்குவதற்கு முன் இந்த கடைக்கு திறந்த காசாளர் அமர்வு தேவை.',
  openingCash: 'தொடக்க பணம்',
  openingCashPlaceholder: 'பணப்பெட்டியில் உள்ள பணத்தை உள்ளிடவும்',

  // Payment modal
  payment: 'கட்டணம்',
  cash: 'பணம்',
  card: 'அட்டை',
  bankTransfer: 'வங்கி பரிமாற்றம்',
  voucher: 'வவுச்சர்',
  loyaltyPoints: 'விசுவாச புள்ளிகள்',
  splitPayment: 'பிரிக்கப்பட்ட கட்டணம்',
  amountDue: 'செலுத்த வேண்டிய தொகை',
  amountTendered: 'வழங்கிய தொகை',
  cashReceived: 'பெறப்பட்ட பணம்',
  change: 'மீதி',
  remaining: 'மீதமுள்ளது',
  paymentReference: 'குறிப்பு (விருப்பம்)',
  paymentComplete: 'விற்பனை முடிந்தது',
  creditSale: 'கடன் விற்பனை',

  // Order discount modal
  applyOrderDiscount: 'ஆர்டர் தள்ளுபடியைப் பயன்படுத்து',
  discountAmount: 'தள்ளுபடி தொகை',
  discountPercent: 'தள்ளுபடி %',
  applyFlat: 'நிலையான தொகை',
  applyPercent: 'சதவீதம்',

  // Loyalty modal
  loyaltyBalance: 'புள்ளிகள் இருப்பு',
  pointsToRedeem: 'மீட்கப்பட வேண்டிய புள்ளிகள்',
  pointValue: 'புள்ளி மதிப்பு',
  discountPreview: 'தள்ளுபடி',
  minPoints: 'குறைந்தபட்சம்',
  maxDiscount: 'அதிகபட்ச தள்ளுபடி',
  redeemPoints: 'புள்ளிகளை மீட்க',
  removeRedemption: 'மீட்பை அகற்று',

  // Hold orders drawer
  holdOrders: 'நிறுத்தி வைக்கப்பட்ட ஆர்டர்கள்',
  noHoldOrders: 'நிறுத்தி வைக்கப்பட்ட ஆர்டர்கள் இல்லை',
  recallOrder: 'மீட்டெடு',
  holdOrderNote: 'தற்போதைய கார்ட் நிறுத்தி வைக்கப்படும்',

  // Customer selector (legacy)
  customerCity: 'நகரம்',
  searchCity: 'நகரத்தைத் தேடு...',
  loyaltyPointsLabel: 'விசுவாச புள்ளிகள்',

  // Receipt
  receipt: 'ரசீது',
  receiptTitle: 'விற்பனை ரசீது',
  orderNumber: 'ஆர்டர் #',
  date: 'தேதி',
  cashier: 'காசாளர்',
  items: 'பொருட்கள்',
  payments: 'கட்டணங்கள்',
  totalPaid: 'மொத்தம் செலுத்தியது',
  balanceDue: 'செலுத்த வேண்டிய இருப்பு',

  // Order list page
  allPosOrders: 'அனைத்து ஆஃப்லைன் விற்பனை ஆர்டர்களும்',
  viewAndManageAllOrders: 'அனைத்து ஆஃப்லைன் விற்பனை ஆர்டர்களையும் பார்க்கவும் நிர்வகிக்கவும்',
  notesPlaceholder: 'இந்த ஆர்டர் பற்றிய குறிப்புகளைச் சேர்க்கவும்...',
  filterByStatus: 'நிலை மூலம் வடிகட்டு',
  filterByPayment: 'கட்டணம் மூலம் வடிகட்டு',
  filterByShop: 'கடை மூலம் வடிகட்டு',
  filterByCashier: 'காசாளர் மூலம் வடிகட்டு',
  dateFrom: 'இருந்து',
  dateTo: 'வரை',
  dateRange: 'தேதி வரம்பு',
  searchOrders: 'ஆர்டர் எண் மூலம் தேடு...',
  searchOrdersPlaceholder: 'ஆர்டர் #, வாடிக்கையாளர் பெயர், தொலைபேசி தேடு...',
  filterByCustomer: 'வாடிக்கையாளர் மூலம் வடிகட்டு',
  filterBySession: 'அமர்வு மூலம் வடிகட்டு',
  allCashiers: 'அனைத்து காசாளர்கள்',
  selectSession: 'அமர்வைத் தேர்ந்தெடுக்கவும்',
  selectDateRangeFirst: 'முதலில் தேதி வரம்பைத் தேர்ந்தெடுக்கவும்',
  noSessionsFound: 'அமர்வுகள் இல்லை',
  searchSessions: 'அமர்வுகளைத் தேடு...',

  status_completed:          'முடிந்தது',
  status_voided:             'ரத்து செய்யப்பட்டது',
  status_on_hold:            'நிறுத்தி வைக்கப்பட்டது',
  status_credit:             'கடன்',
  status_returned:           'திரும்பியது',
  status_partially_returned: 'பகுதியளவு திரும்பியது',

  status_applied:   'விண்ணப்பிக்கப்பட்டது',
  status_delivered: 'வழங்கப்பட்டது',

  payment_paid:    'செலுத்தப்பட்டது',
  payment_partial: 'பகுதி',
  payment_unpaid:  'செலுத்தப்படாத',

  refundMethod_cash:           'பணம்',
  refundMethod_credit_note:    'கடன் குறிப்பு',
  refundMethod_loyalty_points: 'விசுவாச புள்ளிகள்',

  bank_transfer: 'வங்கி இடமாற்றம்',
  cash: 'பணம்',
  card: 'அட்டை',
  payzy: 'Payzy',
  orderNumberCol: 'ஆர்டர் #',
  customerCol: 'வாடிக்கையாளர்',
  cashierCol: 'காசாளர்',
  totalCol: 'மொத்தம்',
  paidCol: 'செலுத்தியது',
  balanceCol: 'இருப்பு',
  statusCol: 'நிலை',
  paymentStatusCol: 'கட்டணம்',
  actionsCol: 'செயல்கள்',
  viewOrder: 'பார்',
  voidOrder: 'ரத்து செய்',
  processReturn: 'திருப்பி அனுப்பு',
  recordPayment: 'கட்டணத்தை பதிவு செய்',
  printReceiptAction: 'ரசீதை அச்சிடு',

  statusCompleted: 'முடிந்தது',
  statusVoided: 'ரத்து செய்யப்பட்டது',
  statusOnHold: 'நிறுத்தி வைக்கப்பட்டது',
  statusCredit: 'கடன்',
  statusReturned: 'திரும்பியது',
  statusPartiallyReturned: 'பகுதியளவு திரும்பியது',
  paymentPaid: 'செலுத்தப்பட்டது',
  paymentPartial: 'பகுதி',
  paymentUnpaid: 'செலுத்தப்படாத',

  voidOrderTitle: 'ஆர்டரை ரத்து செய்',
  voidReason: 'ரத்து செய்வதற்கான காரணம்',
  voidReasonPlaceholder: 'காரணத்தை உள்ளிடவும்...',
  confirmVoid: 'ரத்து செய்வதை உறுதிப்படுத்து',
  voidWarning: 'இந்த செயலை மாற்ற முடியாது. சரக்கு மீட்டெடுக்கப்படும்.',

  processReturnTitle: 'திரும்பப் பெறுதலை செயலாக்கு',
  returnItems: 'திரும்ப அனுப்ப வேண்டிய பொருட்கள்',
  returnQty: 'திரும்ப அனுப்பும் அளவு',
  available: 'கிடைக்கக்கூடியது',
  refundAmount: 'திரும்பச் செலுத்தும் தொகை',
  refundMethod: 'திரும்பச் செலுத்தும் முறை',
  refundCash: 'பண திரும்பப்பணம்',
  refundCreditNote: 'கடன் குறிப்பு',
  refundLoyaltyPoints: 'விசுவாச புள்ளிகள்',
  returnReason: 'திரும்ப அனுப்புவதற்கான காரணம்',
  confirmReturn: 'திரும்ப அனுப்புவதை உறுதிப்படுத்து',
  totalRefund: 'மொத்த திரும்பப்பணம்',

  recordCreditPayment: 'கட்டணத்தை பதிவு செய்',
  outstandingBalance: 'நிலுவை இருப்பு',
  amountToPayNow: 'இப்போது செலுத்த வேண்டிய தொகை',
  confirmPayment: 'கட்டணத்தை உறுதிப்படுத்து',

  allPosCustomers: 'ஆஃப்லைன் விற்பனை வாடிக்கையாளர்கள்',
  addCustomer: 'வாடிக்கையாளரைச் சேர்',
  editCustomer: 'வாடிக்கையாளரைத் திருத்து',
  importCustomers: 'இறக்குமதி செய்',
  backToCustomers: 'வாடிக்கையாளர்களுக்குத் திரும்பு',
  customerNotes: 'குறிப்புகள்',
  customerSecondaryPhone: 'இரண்டாம் தொலைபேசி',
  totalSpend: 'மொத்த செலவு',
  viewHistory: 'வரலாற்றைப் பார்',
  purchaseHistory: 'கொள்முதல் வரலாறு',
  noPurchaseHistory: 'கொள்முதல் வரலாறு இல்லை',
  activeCustomer: 'செயலில்',
  inactiveCustomer: 'செயலற்ற',

  importStep1Title: 'டெம்ப்ளேட்டைப் பதிவிறக்கு',
  importStep1Desc: 'Excel டெம்ப்ளேட்டைப் பதிவிறக்கி, உங்கள் வாடிக்கையாளர் தரவை நிரப்பி, கீழே பதிவேற்றவும்.',
  importStep2Title: 'கோப்பைப் பதிவேற்று',
  importStep3Title: 'முன்னோட்டம் & இறக்குமதி',
  downloadTemplate: 'டெம்ப்ளேட்டைப் பதிவிறக்கு',
  dropZoneText: 'உங்கள் கோப்பை இங்கே இழுத்து விடவும், அல்லது உலாவ கிளிக் செய்யவும்',
  dropZoneSub: '.xlsx, .xls, .csv ஆதரிக்கப்படுகிறது — அதிகபட்சம் 1,000 வரிசைகள்',
  rowsFound: 'வரிசைகள் கண்டறியப்பட்டன',
  previewShowing: 'மொத்தம் {{total}}-இல் முதல் {{shown}} காட்டப்படுகிறது',
  andMoreRows: '...மேலும் {{count}} வரிசைகள்',
  importing: 'இறக்குமதி செய்கிறது...',
  importNCustomers: '{{count}} வாடிக்கையாளர்களை இறக்குமதி செய்',
  importComplete: 'இறக்குமதி முடிந்தது',
  importedCustomers: 'இறக்குமதி செய்யப்பட்டது',
  updatedCustomers: 'புதுப்பிக்கப்பட்டது',
  exportCustomers: 'ஏற்றுமதி',
  exporting: 'ஏற்றுமதி செய்கிறது...',
  skippedRows: 'தவிர்க்கப்பட்டது',
  importErrors: 'பிழைகள்',
  rowLabel: 'வரிசை',
  importAnother: 'மற்றொரு கோப்பை இறக்குமதி செய்',

  cashierSessions: 'காசாளர் அமர்வுகள்',
  openNewSession: 'புதிய அமர்வைத் திற',
  activeSession: 'செயலில் உள்ள அமர்வு',
  noActiveSession: 'செயலில் உள்ள அமர்வு இல்லை',
  closedAt: 'மூடிய நேரம்',
  openedAt: 'திறந்த நேரம்',
  closingCash: 'இறுதி பணம்',
  sessionNotes: 'குறிப்புகள்',
  viewZReport: 'Z-அறிக்கையைப் பார்',
  zReport: 'Z-அறிக்கை',
  zReportTitle: 'அமர்வு முடிவு அறிக்கை',
  totalSales: 'மொத்த விற்பனை',
  storePickupPayments: 'Store Pickup கட்டணங்கள்',
  categoryWiseSales: 'பிரிவு வாரியான விற்பனை',
  categoryOther: 'மற்றவை',
  salesCount: 'விற்பனை எண்ணிக்கை',
  paymentBreakdown: 'கட்டண பிரிவு',
  voidSummary: 'ரத்துகள்',
  returnSummary: 'திரும்பப்பெறுதல்கள்',
  creditSummary: 'நிலுவை கடன்',
  cashExpected: 'எதிர்பார்க்கப்படும் பணம்',
  cashVariance: 'வேறுபாடு',
  selectCashier: 'காசாளரைத் தேர்ந்தெடு',
  createSession: 'அமர்வை உருவாக்கு',
  sessionSummary: 'அமர்வு சுருக்கம்',
  closingAmounts: 'இறுதி தொகைகள் (முறை வாரியாக எண்ணிய பணத்தை உள்ளிடவும்)',
  totalVariance: 'மொத்த வேறுபாடு',
  statusOpen: 'திறந்துள்ளது',
  statusClosed: 'மூடப்பட்டது',

  posSettingsDesc: 'உங்கள் ஆஃப்லைன் விற்பனை கடைகளுக்கான விசுவாச திட்டம் மற்றும் ரசீது வடிவமைப்பை உள்ளமைக்கவும்.',
  loyaltySettings: 'விசுவாச திட்டம்',
  enableLoyalty: 'விசுவாச புள்ளிகளை இயக்கு',
  enableLoyaltyHint: 'வாடிக்கையாளர்கள் கொள்முதலின் மீது புள்ளிகளைப் பெறுவார்கள், அவற்றை தள்ளுபடியாக மீட்கலாம்.',
  pointsPerRupee: 'ரூபாய்க்கு பெறப்படும் புள்ளிகள்',
  pointsPerRupeeHint: 'ரூ. 1 செலவழிக்கும் போது பெறப்படும் புள்ளிகள் எண்ணிக்கை',
  pointValueRupees: 'ஒரு புள்ளிக்கான மதிப்பு (ரூ.)',
  pointValueHint: 'மீட்கும் போது 1 விசுவாச புள்ளியின் ரூபாய் மதிப்பு',
  minRedeemPoints: 'மீட்பதற்கான குறைந்தபட்ச புள்ளிகள்',
  minRedeemHint: 'ஒரு வாடிக்கையாளர் மீட்பதற்கு முன் தேவையான குறைந்தபட்ச புள்ளிகள்',
  maxRedeemPct: 'அதிகபட்ச மீட்பு (ஆர்டரின் %)',
  maxRedeemHint: 'புள்ளிகள் மூலம் தள்ளுபடி செய்யக்கூடிய ஆர்டர் மொத்த தொகையின் அதிகபட்ச %',
  receiptSettings: 'ரசீது அமைப்புகள்',
  receiptHeader: 'ரசீது தலைப்பு',
  receiptFooter: 'ரசீது அடிக்குறிப்பு',
  receiptHeaderPlaceholder: 'தலைப்பு உரையை உள்ளிடவும் (எ.கா. கடை முகவரி, நன்றி செய்தி)',
  receiptFooterPlaceholder: 'அடிக்குறிப்பு உரையை உள்ளிடவும் (எ.கா. திரும்பப் பெறும் கொள்கை)',
  saveSettings: 'அமைப்புகளைச் சேமி',

  auditHistory: 'தணிக்கை வரலாறு',

  cartEmpty: 'கார்ட் காலியாக உள்ளது',
  sessionRequiredError: 'முதலில் ஒரு காசாளர் அமர்வைத் திறக்கவும்',
  insufficientLoyaltyPoints: 'போதுமான விசுவாச புள்ளிகள் இல்லை',
  creditNotAllowed: 'இந்த கடை அல்லது வாடிக்கையாளருக்கு கடன் விற்பனை அனுமதிக்கப்படவில்லை',

  paymentFee: 'கட்டணம்',
  feeAbsorbed: 'வணிகம்',
  feeChargedToCustomer: 'வாடிக்கையாளர்',
  totalPaymentFees: 'மொத்த கட்டண கட்டணங்கள்',
  paymentFeesCustomer: 'கட்டணங்கள் (வாடிக்கையாளர்)',

  shareInvoice: 'இன்வாய்ஸ் பகிர்',
  sendViaWhatsApp: 'WhatsApp',
  sendViaSms: 'SMS அனுப்பு',
  sendingInvoice: 'அனுப்புகிறது…',
  smsSent: 'SMS அனுப்பப்பட்டது',

  productCostCol: 'செலவு',
  paymentFeesCol: 'கட்டணங்கள்',
  profitCol: 'லாபம்',
  totalProductCost: 'தயாரிப்பு செலவு',
  grossProfit: 'மொத்த லாபம்',

  // Create order page (new)
  createOfflineSalesOrder: 'ஆஃப்லைன் விற்பனை ஆர்டரை உருவாக்கு',
  editOfflineSalesOrder: 'ஆஃப்லைன் விற்பனை ஆர்டரைத் திருத்து',
  addNewOfflineOrder: 'கவுன்டர், கடன் அல்லது கூரியர் மூலம் நிறைவேற்றப்படும் ஆஃப்லைன் விற்பனையைப் பதிவு செய்',
  backToOrders: 'ஆர்டர்களுக்குத் திரும்பு',
  shopSelection: 'கடை தேர்வு',
  customerInformation: 'வாடிக்கையாளர்',
  orderItems: 'ஆர்டர் பொருட்கள்',
  fulfillmentMethod: 'நிறைவேற்று முறை',
  counterPickup: 'கவுன்டர் பிக்அப்',
  selfDelivery: 'சுய டெலிவரி',
  courier: 'கூரியர்',
  paymentDetails: 'கட்டண விவரங்கள்',
  addPayment: 'கட்டணத்தைச் சேர்',
  paymentMethod: 'கட்டண முறை',
  selectPaymentMethod: 'கட்டண முறையைத் தேர்ந்தெடு',
  amount: 'தொகை',
  reference: 'குறிப்பு',
  orderDiscount: 'ஆர்டர் தள்ளுபடி',
  orderSummary: 'ஆர்டர் சுருக்கம்',
  subtotal: 'கூட்டுத்தொகை',
  discount: 'தள்ளுபடி',
  tax: 'வரி',
  grandTotal: 'மொத்த தொகை',
  paidAmount: 'செலுத்திய தொகை',
  balanceAmount: 'இருப்பு (கடன்)',
  notes: 'குறிப்புகள்',
  createOrder: 'ஆர்டரை உருவாக்கு',
  someFieldsRequired: 'சமர்ப்பிக்கும் முன் குறிப்பிடப்பட்ட புலங்களை சரிசெய்யவும்',
  orderCreatedSuccess: 'ஆர்டர் {orderNumber} வெற்றிகரமாக உருவாக்கப்பட்டது',
  orderUpdatedSuccess: 'ஆணை வெற்றிகரமாக புதுப்பிக்கப்பட்டது',
  failedToCreateOrder: 'ஆர்டரை உருவாக்குவதில் தோல்வி',

  creditLimitWarningTitle: 'கடன் வரம்பு மீறப்பட்டது',
  creditLimitWarningMessage: 'இந்த வாடிக்கையாளரின் நிலுவை இருப்பு (இந்த ஆர்டர் உட்பட) அவர்களின் கடன் வரம்பை மீறுகிறது. ஆர்டர் இன்னும் உருவாக்கப்பட்டது — மேலும் கடன் வழங்குவதற்கு முன் மதிப்பாய்வு செய்யவும்.',

  searchProducts: 'தயாரிப்புகளைத் தேடு அல்லது பார்கோடை ஸ்கேன் செய்',
  noProductsFound: 'தயாரிப்புகள் இல்லை',
  removeItem: 'பொருளை அகற்று',
  quantity: 'அளவு',
  unitPrice: 'அலகு விலை',
  lineDiscount: 'தள்ளுபடி',
  lineTotal: 'மொத்தம்',
  noItemsAdded: 'இன்னும் பொருட்கள் சேர்க்கப்படவில்லை',

  selectCustomer: 'வாடிக்கையாளரைத் தேர்ந்தெடு',
  searchCustomers: 'பெயர் அல்லது தொலைபேசி மூலம் வாடிக்கையாளர்களைத் தேடு',
  cashSales: 'பண விற்பனை',
  noCustomersFound: 'வாடிக்கையாளர்கள் இல்லை',
  newCustomer: 'புதிய வாடிக்கையாளர்',
  customerName: 'வாடிக்கையாளர் பெயர்',
  customerNamePlaceholder: 'வாடிக்கையாளர் பெயரை உள்ளிடவும்',
  customerPhone: 'தொலைபேசி',
  customerEmail: 'மின்னஞ்சல்',
  customerEmailPlaceholder: 'மின்னஞ்சல் முகவரியை உள்ளிடவும்',
  customerAddress: 'முகவரி',
  customerAddressPlaceholder: 'முகவரியை உள்ளிடவும்',
  customerNotesPlaceholder: 'இந்த வாடிக்கையாளர் பற்றிய குறிப்புகளைச் சேர்க்கவும்',
  creditLimit: 'கடன் வரம்பு',
  creditLimitPlaceholder: 'கடன் வரம்பை உள்ளிடவும்',
  creditTermDays: 'கடன் காலம் (நாட்கள்)',
  creditTermDaysPlaceholder: 'கடன் காலம் நாட்களை உள்ளிடவும்',
  failedToCreateCustomer: 'வாடிக்கையாளரை உருவாக்குவதில் தோல்வி',
  customerCreatedSuccess: 'வாடிக்கையாளர் வெற்றிகரமாக உருவாக்கப்பட்டார்',
  changeCustomer: 'மாற்று',
  salesRep: 'விற்பனை பிரதிநிதி',
  selectSalesRep: 'விற்பனை பிரதிநிதியைத் தேர்ந்தெடுக்கவும்',
  assignSalesRep: 'விற்பனை பிரதிநிதியை ஒதுக்கு',
  salesRepAssigned: 'விற்பனை பிரதிநிதி புதுப்பிக்கப்பட்டது',
  salesRepAssignFailed: 'விற்பனை பிரதிநிதியைப் புதுப்பிக்க முடியவில்லை',
  salesRepSettings: 'விற்பனை பிரதிநிதிகள்',
  salesRepRoles: 'விற்பனை பிரதிநிதி பாத்திரங்கள்',
  salesRepRolesPlaceholder: 'அனைத்து பயனர்களும்',
  salesRepRolesHint: 'இந்தப் பாத்திரங்களில் உள்ள பயனர்களை மட்டுமே ஆஃப்லைன் ஆர்டர்களில் விற்பனை பிரதிநிதிகளாகத் தேர்ந்தெடுக்க முடியும். எதுவும் தேர்ந்தெடுக்கப்படவில்லை என்றால், அனைத்து பயனர்களும் காட்டப்படுவார்கள்.',

  // Customer location picker
  customerLocation: 'Location', // TODO: ta translation
  locationSearchPlaceholder: 'இலங்கையில் ஒரு இடத்தைத் தேடுங்கள்',
  locationSearchButton: 'தேடு',
  locationSearchNoResults: 'முடிவுகள் இல்லை',
  locationUseMyLocation: 'எனது தற்போதைய இருப்பிடத்தைப் பயன்படுத்து',
  locationDetecting: 'உங்கள் இருப்பிடத்தை கண்டறிகிறது...',
  locationPermissionDenied: 'இருப்பிட அனுமதி மறுக்கப்பட்டது. இருப்பிட அணுகலை அனுமதிக்கவும் அல்லது வரைபடத்தில் தேர்ந்தெடுக்கவும்.',
  locationUnavailable: 'உங்கள் இருப்பிடத்தை தீர்மானிக்க முடியவில்லை. வரைபடத்தில் தேர்ந்தெடுக்கவும்.',
  locationTimeout: 'இருப்பிட கோரிக்கை காலாவதியானது. மீண்டும் முயற்சிக்கவும் அல்லது வரைபடத்தில் தேர்ந்தெடுக்கவும்.',
  locationNotSupported: 'உங்கள் உலாவி இருப்பிடத்தை கண்டறிதலை ஆதரிக்கவில்லை. வரைபடத்தில் தேர்ந்தெடுக்கவும்.',
  locationNearbyAddress: 'அருகிலுள்ள முகவரி',
  locationNearbyAddressUnavailable: 'இந்த இடத்திற்கான அருகிலுள்ள முகவரியைக் கண்டறிய முடியவில்லை',
  locationGoogleLinkLabel: 'அல்லது Google Maps இணைப்பை ஒட்டவும்',
  locationGoogleLinkPlaceholder: 'Google Maps இணைப்பை ஒட்டவும்',
  locationUseLinkButton: 'இணைப்பைப் பயன்படுத்து',
  locationGoogleLinkInvalid: 'இந்த இணைப்பிலிருந்து ஆயத்தொலைவுகளைப் படிக்க முடியவில்லை',
  locationLatitude: 'அட்சரேகை',
  locationLongitude: 'தீர்க்கரேகை',
  locationClear: 'இருப்பிடத்தை அழி',

  receivablesDescription: 'கடன் மற்றும் பகுதியளவு திரும்பப் பெறப்பட்ட ஆஃப்லைன் விற்பனைகளிலிருந்து நிலுவை வாடிக்கையாளர் இருப்புகள்',
  totalOutstanding: 'மொத்த நிலுவை',
  customer: 'வாடிக்கையாளர்',
  phone: 'தொலைபேசி',
  aging0to30: '0-30 நாட்கள்',
  aging31to60: '31-60 நாட்கள்',
  aging61to90: '61-90 நாட்கள்',
  aging90plus: '90+ நாட்கள்',
  noReceivablesFound: 'நிலுவை பெறத்தக்கவை இல்லை',
  noReceivablesFoundDescription: 'அனைத்து ஆஃப்லைன் விற்பனை வாடிக்கையாளர் இருப்புகளும் தீர்க்கப்பட்டுள்ளன',
  failedToLoadReceivables: 'பெறத்தக்கவைகளை ஏற்றுவதில் தோல்வி',
  searchByCustomerName: 'வாடிக்கையாளர் பெயர் அல்லது தொலைபேசி மூலம் தேடு',

  // Session gate / packing (shared, Stage 8 groundwork)
  warehouse: 'கிடங்கு',
  sessionRequiredTitle: 'காசாளர் அமர்வு தேவை',
  sessionLoading: 'காசாளர் அமர்வு சரிபார்க்கப்படுகிறது...',
  sessionNotFound: 'ஆர்டர் உருவாக்கும் முன் இந்த கடைக்கு காசாளர் அமர்வைத் திறக்கவும்',
  customerStatement: 'வாடிக்கையாளர் கணக்கு அறிக்கை',
  openingBalance: 'தொடக்க இருப்பு',
  closingBalance: 'இறுதி இருப்பு',
  type: 'வகை',
  transactionType_invoice: 'விலைப்பட்டியல்',
  transactionType_payment: 'பெறப்பட்ட கட்டணம்',
  transactionType_credit_note: 'வரவுக் குறிப்பு',
  transactionType_return: 'பணத் திருப்பம்',
  debit: 'பற்று',
  credit: 'வரவு',
  selectDateRange: 'தேதி வரம்பைத் தேர்ந்தெடுக்கவும்',
  noTransactionsFound: 'பரிவர்த்தனைகள் எதுவும் இல்லை',
  noTransactionsFoundDescription: 'தேர்ந்தெடுக்கப்பட்ட தேதி வரம்பில் பரிவர்த்தனைகள் இல்லை',
  paymentRecordedSuccess: 'பணம் வெற்றிகரமாக பதிவு செய்யப்பட்டது',
  failedToRecordPayment: 'பணம் பதிவு செய்யத் தவறிவிட்டது',
  creditNotePaymentMethod: 'Credit Note',
  selectCreditNote: 'Select Credit Note',
  searchCreditNote: 'Search credit notes...',
  noAvailableCreditNotes: 'No available credit notes',
  applyCreditNotePayment: 'Apply Credit Note',
  offlinePacking: 'ஆஃப்லைன் கூரியர் பேக்கிங்',
  offlinePackingDescription: 'கூரியர் மூலம் அனுப்பப்படும் ஆஃப்லைன் ஆர்டர்களை அனுப்புவதற்குத் தயார்படுத்தவும்',
  viewMixedPackingQueue: 'கலப்பு வரிசையைப் பார்க்கவும்',
  offlinePackingBatchList: 'ஆஃப்லைன் கூரியர் பேக்கிங் தொகுதிகள்',
  offlinePackingBatchListDescription: 'அனைத்து ஆஃப்லைன் கூரியர் பேக்கிங் தொகுதிகளையும் பார்க்கவும் நிர்வகிக்கவும்',
  courierAccount: 'கூரியர் கணக்கு',
  selectCourierAccount: 'கூரியர் கணக்கைத் தேர்ந்தெடுக்கவும்',
  searchPackingOrders: 'ஆர்டர் எண் அல்லது வாடிக்கையாளரைத் தேடு',
  failedToLoadPackingReferences: 'பேக்கிங் குறிப்புகளை ஏற்றுவதில் தோல்வி',
  selectPackingReferences: 'முதலில் ஒரு கிடங்கு மற்றும் கூரியர் கணக்கைத் தேர்ந்தெடுக்கவும்',
  failedToLoadPackingOrders: 'ஆஃப்லைன் கூரியர் ஆர்டர்களை ஏற்றுவதில் தோல்வி',
  selectPackingOrders: 'குறைந்தது ஒரு ஆர்டரையாவது தேர்ந்தெடுக்கவும்',
  packingBatchCreated: 'பேக்கிங் தொகுதி வெற்றிகரமாக உருவாக்கப்பட்டது',
  failedToCreatePackingBatch: 'பேக்கிங் தொகுதியை உருவாக்குவதில் தோல்வி',
  selectPackingOrder: 'ஆர்டர் {orderNumber} ஐத் தேர்ந்தெடுக்கவும்',
  selectedPackingOrders: '{count} ஆர்டர்கள் தேர்ந்தெடுக்கப்பட்டன',
  createPackingBatch: 'பேக்கிங் தொகுதியை உருவாக்கு',
  noPackingOrders: 'ஆஃப்லைன் கூரியர் ஆர்டர்கள் எதுவும் இல்லை',
  noPackingOrdersDescription: 'தகுதியான ஆர்டர்களைத் தேட ஒரு கிடங்கு மற்றும் கூரியர் கணக்கைத் தேர்ந்தெடுக்கவும்',
  // Order audit history
  auditEmpty: "காலி",
  auditBy: "{{name}} மூலம்",
  audit_CREATE: "ஆர்டர் உருவாக்கப்பட்டது",
  audit_UPDATE: "ஆர்டர் புதுப்பிக்கப்பட்டது",
  audit_STATUS_CHANGE: "நிலை மாற்றப்பட்டது",
  audit_DELETE: "அகற்றப்பட்டது",
  audit_payment_CREATE: "கட்டணம் பதிவு செய்யப்பட்டது",
  audit_payment_UPDATE: "கட்டணம் புதுப்பிக்கப்பட்டது",
  audit_payment_DELETE: "கட்டணம் அகற்றப்பட்டது",
  audit_payment_customer_payment_applied: "வாடிக்கையாளர் கட்டணம் பயன்படுத்தப்பட்டது",
  audit_payment_customer_payment_voided: "வாடிக்கையாளர் கட்டணம் ரத்து செய்யப்பட்டது",
  audit_payment_cheque_bounced: "காசோலை திரும்பியது",
  audit_quotation_CONVERTED: "விலைப்பட்டியலிலிருந்து மாற்றப்பட்டது",
  audit_order_items_UPDATED: "ஆர்டர் பொருட்கள் புதுப்பிக்கப்பட்டன",
  audit_order_items_CREATED: "ஆர்டர் பொருட்கள் சேர்க்கப்பட்டன",
  audit_delivery_note_CREATED: "டெலிவரி குறிப்பு உருவாக்கப்பட்டது",
  audit_return_note_CREATED: "திருப்பக் குறிப்பு உருவாக்கப்பட்டது",
  audit_return_note_VOIDED: "திருப்பக் குறிப்பு ரத்து செய்யப்பட்டது",
  audit_credit_note_ISSUED: "கடன் குறிப்பு வழங்கப்பட்டது",
  audit_credit_note_APPLIED: "கடன் குறிப்பு பயன்படுத்தப்பட்டது",
  audit_credit_note_CANCELLED: "கடன் குறிப்பு ரத்து செய்யப்பட்டது",
  auditTag_payment: "கட்டணப் பதிவு",
  auditTag_quotation: "விலைப்பட்டியல்",
  auditTag_order_items: "ஆர்டர் பொருட்கள்",
  auditTag_delivery_note: "டெலிவரி குறிப்பு",
  auditTag_return_note: "திருப்பக் குறிப்பு",
  auditTag_credit_note: "கடன் குறிப்பு",
  auditItemAdded: "சேர்க்கப்பட்டது",
  auditItemRemoved: "அகற்றப்பட்டது",
  auditItemUpdated: "புதுப்பிக்கப்பட்டது",
  auditField_orderStatus: "ஆர்டர் நிலை",
  auditField_status: "நிலை",
  auditField_quantity: "அளவு",
  freeUnits: "இலவசம்",
  freeUnitsHint: "இலவசமாக வழங்கப்படும் அலகுகள் (அளவில் சேர்க்கப்பட்டது)",
  showFreeUnits: "இலவச அலகுகளைச் சேர்க்கவும்",
  freeUnitsCustom: "தனிப்பயன் அளவு",
  freeUnitsApply: "பயன்படுத்து",
  itemsIncludedFree: "{{count}} இலவச பொருள்(கள்) சேர்க்கப்பட்டுள்ளது",
  totalDiscountLabel: "மொத்தம் Rs. {{total}}",
  inclFreeValue: "{{count}} இலவசத்திற்கு Rs. {{value}} உட்பட",
  auditField_freeQuantity: "இலவச அலகுகள்",
  customerType: "வாடிக்கையாளர் வகை",
  selectCustomerType: "வாடிக்கையாளர் வகையைத் தேர்ந்தெடுக்கவும்",
  customerCategory: "வாடிக்கையாளர் பிரிவு",
  selectCustomerCategory: "வாடிக்கையாளர் பிரிவைத் தேர்ந்தெடுக்கவும்",
  addCustomerCategory: "புதிய பிரிவைச் சேர்க்கவும்",
  customerCategoryNamePlaceholder: "பிரிவின் பெயரை உள்ளிடவும்",
  customerCategoryCreated: "வாடிக்கையாளர் பிரிவு \"{name}\" உருவாக்கப்பட்டது",
  customerCategoryCreateFailed: "வாடிக்கையாளர் பிரிவை உருவாக்க முடியவில்லை",
  tinNumber: "TIN எண்",
  tinNumberPlaceholder: "TIN எண்ணை உள்ளிடவும்",
  vatNumber: "VAT எண்",
  vatNumberPlaceholder: "VAT எண்ணை உள்ளிடவும்",
  auditField_unitPrice: "அலகு விலை",
  auditField_lineDiscount: "வரி தள்ளுபடி",
  auditField_lineTotal: "வரி மொத்தம்",
  auditField_refundMethod: "திருப்பிச் செலுத்தும் முறை",
  auditField_totalRefundAmount: "திருப்பித் தொகை",
  auditField_creditNoteNumber: "கடன் குறிப்பு",
  auditField_amount: "தொகை",
  auditField_appliedAmount: "பயன்படுத்திய தொகை",
  auditField_sourceType: "மூலம்",
  auditField_receivedByName: "பெற்றவர்",
  auditField_notes: "குறிப்புகள்",
  // Customer payments, opening balances & cheques
  statusPending: 'நிலுவையில்',
  statusInCourier: 'கூரியரில்',
  transactionType_opening_balance: 'தொடக்க இருப்பு',
  transactionType_customer_payment: 'வாடிக்கையாளர் கட்டணம்',
  transactionType_customer_payment_reversal: 'கட்டணம் திரும்பப்பெறப்பட்டது',
  chqDetails: 'காசோலை விவரங்கள்',
  chqDate: 'காசோலை தேதி',
  chqPostDated: 'பின்தேதியிட்ட காசோலை',
  chqPostDatedHint: 'காசோலை எதிர்கால தேதிக்கு இருந்தால் குறியிடவும் — அப்போது காசோலை தேதி தேவை',
  chqSelectDate: 'தேதியைத் தேர்ந்தெடுக்கவும்',
  chqDateRequired: 'பின்தேதியிட்ட காசோலைக்கு தேதி தேவை',
  chqDateMustBeFuture: 'பின்தேதியிட்ட காசோலை தேதி இன்றைக்குப் பிறகு இருக்க வேண்டும்',
  chqTitle: 'காசோலைகள்',
  chqDescription: 'பெறப்பட்ட காசோலைகளைக் கண்காணித்து இன்று வைப்புச் செய்யக்கூடியவற்றைப் பார்க்கவும்',
  chqView_all: 'அனைத்தும்',
  chqView_depositable: 'இப்போது வைப்புச் செய்யலாம்',
  chqView_post_dated: 'பின்தேதியிட்டவை (நிலுவை இல்லை)',
  chqView_deposited: 'வைப்புச் செய்யப்பட்டது',
  chqView_cleared: 'தீர்க்கப்பட்டது',
  chqView_bounced: 'திரும்பியது',
  chqStatus_pending: 'நிலுவையில்',
  chqStatus_deposited: 'வைப்புச் செய்யப்பட்டது',
  chqStatus_cleared: 'தீர்க்கப்பட்டது',
  chqStatus_bounced: 'திரும்பியது',
  chqView_cancelled: 'ரத்துசெய்யப்பட்டது',
  chqStatus_cancelled: 'ரத்துசெய்யப்பட்டது',
  chqMarkDeposited: 'வைப்புச் செய்யப்பட்டதாகக் குறி',
  chqMarkCleared: 'தீர்க்கப்பட்டதாகக் குறி',
  chqMarkBounced: 'திரும்பியதாகக் குறி',
  chqBounceConfirm: 'இந்தக் காசோலையை திரும்பியதாகக் குறிக்கவா? தொடர்புடைய கட்டணம் திரும்பப்பெறப்படும்.',
  chqDepositConfirm: 'இந்தக் காசோலையை வைப்பு செய்ததாகக் குறிக்கவா?',
  chqStatusUpdated: 'காசோலை நிலை புதுப்பிக்கப்பட்டது',
  chqFailedToUpdate: 'காசோலையைப் புதுப்பிக்க முடியவில்லை',
  chqFailedToLoad: 'காசோலைகளை ஏற்ற முடியவில்லை',
  chqNotYetDue: 'வைப்புக்கு இன்னும் நிலுவை இல்லை',
  chqDueInDays: '{days} நாளில் நிலுவை',
  chqNotYetDueOn: '{date} வரை வைப்புக்கு நிலுவை இல்லை ({days} நாள் மீதம்)',
  cpPaymentDate: 'கட்டண தேதி',
  cpReference: 'குறிப்பு',
  cpProof: 'கட்டண சான்று',
  cpViewProof: 'சான்றைக் காண்க',
  cpViewFile: 'கோப்பைக் காண்க',
  cpView: 'கட்டணத்தைக் காண்க',
  cpFilterCustomer: 'வாடிக்கையாளர்',
  cpFilterMethod: 'கட்டண முறை',
  cpDetailTitle: 'வாடிக்கையாளர் கட்டணம்',
  cpAllocations: 'பயன்படுத்தப்பட்டது',
  cpAllocatedTo: 'விலைப்பட்டியல் / இருப்பு',
  cpAsOfDate: 'தேதியின்படி',
  cpInvoiceTotal: 'விலைப்பட்டியல் மொத்தம்',
  cpAmountApplied: 'பயன்படுத்திய தொகை',
  cpReceivedBy: 'பெற்றவர்',
  cpNoAllocations: 'இந்தக் கட்டணம் எந்த இருப்புக்கும் பயன்படுத்தப்படவில்லை',
  chqPdcTag: 'பின்தேதி',
  chqLinkedTo: 'இணைக்கப்பட்டது',
  chqCount: '{count} காசோலை(கள்)',
  chqSearchPlaceholder: 'வாடிக்கையாளரைத் தேடுக',
  chqDateRange: 'காசோலை தேதி வரம்பு',
  chqEmpty: 'காசோலைகள் இல்லை',
  chqEmptyDescription: 'தேர்ந்தெடுத்த பார்வைக்கு பொருந்தும் காசோலைகள் இல்லை',
  chqPdcInHand: 'கையிலுள்ள காசோலைகள்',
  cpTitle: 'வாடிக்கையாளர் கட்டணங்கள்',
  cpDescription: 'வாடிக்கையாளர்களிடமிருந்து பெற்ற கட்டணங்கள், பழைய நிலுவைகளுக்கு முதலில் தானாகப் பயன்படுத்தப்படும்',
  cpReceivePayment: 'கட்டணம் பெறுக',
  cpReceiveDescription: 'விலைப்பட்டியலைத் தேர்ந்தெடுக்காமல் கட்டணத்தைப் பதிவுசெய்க — முதலில் தொடக்க இருப்பு, பின்னர் பழைய விலைப்பட்டியல்கள்',
  cpPaymentDetails: 'கட்டண விவரங்கள்',
  cpMethod: 'கட்டண முறை',
  cpNotes: 'குறிப்புகள்',
  cpSave: 'கட்டணத்தைச் சேமி',
  cpSaved: 'வாடிக்கையாளர் கட்டணம் பதிவுசெய்யப்பட்டது',
  cpFailedToSave: 'கட்டணத்தைப் பதிவுசெய்ய முடியவில்லை',
  cpFailedToLoad: 'வாடிக்கையாளர் கட்டணங்களை ஏற்ற முடியவில்லை',
  cpFailedToPreview: 'நிலுவைகளை ஏற்ற முடியவில்லை',
  cpSelectCustomerFirst: 'நிலுவைகளைப் பார்க்க வாடிக்கையாளரைத் தேர்ந்தெடுக்கவும்',
  cpSelectMethod: 'கட்டண முறையைத் தேர்ந்தெடுக்கவும்',
  cpAmountRequired: 'தொகை 0 ஐ விட அதிகமாக இருக்க வேண்டும்',
  cpAllocationPreview: 'ஒதுக்கீட்டு முன்னோட்டம்',
  cpFifoHint: 'பழையது முதலில்: தொடக்க இருப்பு, பின்னர் தேதி வாரியாக விலைப்பட்டியல்கள்',
  cpOutstanding: 'நிலுவை',
  cpApplied: 'பயன்படுத்தப்பட்டது',
  cpRemaining: 'மீதம்',
  cpNoOpenItems: 'நிலுவை இல்லை',
  cpNoOpenItemsDescription: 'இந்த வாடிக்கையாளருக்கு நிலுவை இல்லை — கட்டணம் வரவாக வைக்கப்படும்',
  cpExistingCredit: 'ஒதுக்கப்படாத தற்போதைய வரவு',
  cpWillBeCredit: '{amount} வாடிக்கையாளர் வரவாக வைக்கப்படும்',
  cpNumber: 'ரசீது எண்',
  cpUnallocated: 'ஒதுக்கப்படாதது',
  cpUnallocatedCredit: 'ஒதுக்கப்படாத வரவு',
  cpAppliedTo: 'பயன்படுத்தப்பட்டது',
  cpStatus_active: 'செயலில்',
  cpStatus_void: 'ரத்து',
  cpVoid: 'கட்டணத்தை ரத்துசெய்',
  cpVoidConfirm: '{number} கட்டணத்தை ரத்துசெய்யவா? அதன் ஒதுக்கீடுகள் திரும்பப்பெறப்படும்.',
  cpVoided: 'வாடிக்கையாளர் கட்டணம் ரத்துசெய்யப்பட்டது',
  cpFailedToVoid: 'கட்டணத்தை ரத்துசெய்ய முடியவில்லை',
  cpSearchPlaceholder: 'ரசீது எண், குறிப்பு அல்லது வாடிக்கையாளரைத் தேடுக',
  cpEmpty: 'இன்னும் வாடிக்கையாளர் கட்டணங்கள் இல்லை',
  cpEmptyDescription: '"கட்டணம் பெறுக" மூலம் பெற்ற கட்டணங்கள் இங்கே தோன்றும்',
  obAmount: 'தொடக்க இருப்புத் தொகை',
  obAsOfDate: 'தேதியின்படி',
  obDateRequired: 'தேதி தேவை',
  obAmountRequired: 'தேதி அமைக்கப்பட்டால் தொடக்க இருப்பு தேவை',
  cusCode: 'வாடிக்கையாளர் குறியீடு',
  cusCodePlaceholder: 'காலியாக இருந்தால் தானாக உருவாக்கப்படும்',
  cusCodeExists: 'இந்த வாடிக்கையாளர் குறியீடு ஏற்கனவே பயன்பாட்டில் உள்ளது',
  cusCodeInvalid: 'எழுத்துகள், எண்கள் மற்றும் கோடுகள் மட்டும் (அதிகபட்சம் 20)',
  nameRequired: 'வாடிக்கையாளர் பெயர் தேவை',
  invalidPhone: 'சரியான தொலைபேசி எண்ணை உள்ளிடவும்',
  phoneExists: 'இந்த தொலைபேசி எண்ணுடன் ஒரு வாடிக்கையாளர் ஏற்கனவே உள்ளார்',
  secondarySameAsPrimary: 'இரண்டாம் தொலைபேசி முதன்மை எண்ணிலிருந்து வேறுபட வேண்டும்',
  invalidEmail: 'சரியான மின்னஞ்சல் முகவரியை உள்ளிடவும்',
  mustBeNonNegative: '0 அல்லது அதற்கு மேல் இருக்க வேண்டும்',
  mustBeWholeNumber: '0 அல்லது அதற்கு மேற்பட்ட முழு எண்ணாக இருக்க வேண்டும்',
  obDateFuture: 'தேதி எதிர்காலத்தில் இருக்க முடியாது',
  obLocked: 'இந்த இருப்புக்கு எதிராக {paid} ஏற்கனவே செலுத்தப்பட்டுள்ளது — திருத்த அந்தக் கட்டணங்களை ரத்துசெய்யவும்',
};
